import axios from 'axios'

export const state = {
  outlets: [],
}

export const getters = {
  getOutlets() {
    return state.outlets
  },
}

export const mutations = {
  SET_OUTLET(state, outlets) {
    state.outlets = outlets
  },
}

export const actions = {
  createOutlets({
    commit,
    state
  }, {
    outletDetails
  }) {
    return axios
      .post(`v1/outlets/`, outletDetails)
      .then(response => {
        return response
      })
  },
  getAllOutlets({
    commit
  }, outletID) {
    return axios.get(`v1/outlets/get/${outletID}`).then(response => {
      return response
    })
  },


  setAllOutlets({
    commit,
    state
  }, outlets) {
    commit('SET_OUTLET', outlets)
  },

  updateOutlets({
    commit,
    state
  }, {
    outletDetails
  }) {
    return axios
      .put(`v1/outlets/update/`, outletDetails)
      .then(response => {
        return response
      })
  },
}
